// @ts-nocheck

const basketDelBonus = (state, action) => {
  const { promotionId } = action.payload;
  const { bonuses } = state;
  return {
    ...state,
    bonuses: {
      ...bonuses,
      [promotionId]: {
        ...bonuses[promotionId],
        deleted: true,
      },
    },
  };
};

export default basketDelBonus;
